import { computed, isUninitialized } from "@tldraw/state";
import { ShapeUtil } from "../shapes/ShapeUtil.mjs";
function notVisibleShapes(editor) {
  const emptySet = /* @__PURE__ */ new Set();
  const defaultCanCull = ShapeUtil.prototype.canCull;
  return computed("notVisibleShapes", function(prevValue) {
    const allShapeIds = editor.getCurrentPageShapeIds();
    const viewportPageBounds = editor.getViewportPageBounds();
    const visibleIds = editor.getShapeIdsInsideBounds(viewportPageBounds);
    if (visibleIds.size === allShapeIds.size) {
      if (isUninitialized(prevValue) || prevValue.size > 0) {
        return emptySet;
      }
      return prevValue;
    }
    const notVisibleIds = /* @__PURE__ */ new Set();
    for (const id of allShapeIds) {
      if (visibleIds.has(id)) continue;
      const peek = editor.store.unsafeGetWithoutCapture(id);
      if (!peek) continue;
      const util = editor.getShapeUtil(peek.type);
      if (util.canCull === defaultCanCull) {
        notVisibleIds.add(id);
        continue;
      }
      const shape = editor.getShape(id);
      if (!shape) continue;
      if (!util.canCull(shape)) continue;
      notVisibleIds.add(id);
    }
    if (isUninitialized(prevValue)) {
      return notVisibleIds;
    }
    if (notVisibleIds.size === prevValue.size) {
      let same = true;
      for (const id of notVisibleIds) {
        if (!prevValue.has(id)) {
          same = false;
          break;
        }
      }
      if (same) return prevValue;
    }
    return notVisibleIds;
  });
}
export {
  notVisibleShapes
};
//# sourceMappingURL=notVisibleShapes.mjs.map
